import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="row justify-content-center">
      <div className="col-md-6 text-center py-5">
        <h1 className="display-4 mb-3">404</h1>
        <h4 className="mb-3">Página no encontrada</h4>
        <p className="text-muted mb-4">
          La dirección a la que intentas entrar no existe o fue movida.
        </p>
        <Link className="btn btn-primary" to="/">
          Volver al inicio
        </Link>
      </div>
    </div>
  );
}
